export default function (value) {
  if (value === 0) return '0 rows';
  if (value === 1) return `${value} row`;
  return `${value} rows`;
}
